import { Typography } from '@weareopenr/component-library';

export interface NoResultsFoundProps {
  searchQuery?: string;
  hasActiveFilters?: boolean;
  size?: 'medium' | 'large';
}

export const NoResultsFound = ({ searchQuery, hasActiveFilters, size = 'medium' }: NoResultsFoundProps) => {
  if (searchQuery) {
    return (
      <div>
        <Typography size={size} inline>
          No results found for{' '}
        </Typography>
        <Typography size={size} weight="semi-bold" inline>
          &quot;{searchQuery}&quot;
        </Typography>
      </div>
    );
  }

  if (hasActiveFilters) {
    return <Typography size={size}>No results found for the selected filters</Typography>;
  }

  return <Typography size={size}>No results found</Typography>;
};
